import React from 'react';
import PropTypes from 'prop-types';

import InfoContainer from './InfoContainer';
import TopStub from './TopStub';
import MiddleStub from './MiddleStub';

class CardStub extends React.PureComponent {
  render() {
    return (
      <div style={{ borderRadius: '4px', overflow: 'hidden' }}>
        <TopStub />

        <InfoContainer>
          {this.props.showCountStub && (
            <MiddleStub style={{ width: '120px', marginBottom: '12px' }} />
          )}

          <MiddleStub style={{ width: '212px', marginBottom: 'auto' }} />

          <MiddleStub style={{ width: '80px', marginBottom: '24px' }} />
        </InfoContainer>
      </div>
    );
  }
}

CardStub.propTypes = {
  showCountStub: PropTypes.bool,
};

CardStub.defaultProps = {
  showCountStub: false,
};

export default CardStub;
